import { useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDown, LogOut, User } from "lucide-react";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function ProfileDropdown() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const renderAvatar = () => {
    if (user?.photoURL && !imageError) {
      return (
        <img
          src={user.photoURL}
          alt="Avatar"
          className="w-8 h-8 rounded-full object-cover"
          onError={() => setImageError(true)}
        />
      );
    }

    return (
      <div className="w-8 h-8 rounded-full bg-yellow-600 flex items-center justify-center text-white font-bold">
        {user?.email ? user.email.charAt(0).toUpperCase() : "?"}
      </div>
    );
  };

  return (
    <div className="relative inline-block text-left">
      <Menu>
        <Menu.Button className="flex items-center gap-2 bg-gray-100 p-2 rounded-full hover:shadow-md transition">
          {renderAvatar()}
          <ChevronDown className="w-4 h-4 text-gray-600" />
        </Menu.Button>

        <Transition
          enter="transition ease-out duration-100"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Menu.Items className="absolute right-0 mt-2 w-48 bg-white border rounded-md shadow-lg z-50 focus:outline-none">
            <div className="p-4 text-center">
              <p className="text-sm font-medium text-gray-700">{user?.displayName || "Usuario"}</p>
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
            </div>
            <div className="border-t" />
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate("/perfil")}
                  className={`${
                    active ? "bg-gray-100" : ""
                  } flex items-center w-full px-4 py-2 text-sm text-gray-700`}
                >
                  <User className="w-4 h-4 mr-2" />
                  Perfil
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={handleLogout}
                  className={`${
                    active ? "bg-gray-100" : ""
                  } flex items-center w-full px-4 py-2 text-sm text-gray-700`}
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Cerrar sesión
                </button>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
